import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { omniAtom, omniAtomWithStorage } from "src/utils/atoms";
import type { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { PlanogramContainerCommonNonCircular } from "@CommonTypes/merchflow/pog/container";
import { PlanogramPegboardPlacement } from "@CommonTypes/merchflow/pog/pegboard";
import type { PlanogramSelectedItem } from "src/components/Planogram/common/planogramSelection";

const prefix = "planogram/extensions";

export const planogramImagesModeAtom = omniAtomWithStorage({
  prefix,
  key: "imagesMode",
  value: true,
});

export const planogramHoveredItemAtom = omniAtom({
  prefix,
  key: "hovered/product",
  value: null as PlanogramItem | null,
});

export const planogramHoveredPegboardPlacementAtom = omniAtom({
  prefix,
  key: "hovered/pegboardPlacement",
  value: null as PlanogramPegboardPlacement | null,
});

export const planogramHoveredContainerAtom = omniAtom({
  prefix,
  key: "hovered/container",
  value: null as PlanogramContainerCommonNonCircular | null,
});

export const planogramHoveredShelfAtom = omniAtom({
  prefix,
  key: "hovered/shelf",
  value: null as PlanogramShelf | null,
});

export const planogramItemSearcherAtom = omniAtom({
  prefix,
  key: "itemSearcher",
  value: "",
});

export const planogramSelectedShelfAtom = omniAtom({
  prefix,
  key: "selectedShelf",
  value: null as (PlanogramShelf & { isNew?: boolean }) | null,
});

export const planogramSelectedShelvesAtom = omniAtom({
  prefix,
  key: "selectedShelves",
  value: [] as string[],
});

export const labelOptionAtom = omniAtomWithStorage<keyof PlanogramItem | "none">({
  prefix,
  key: "labelOption",
  value: "cdt1",
});

// Label options pinned to the top of the labels dropdown, persisted per browser.
export const pinnedLabelOptionsAtom = omniAtomWithStorage<(keyof PlanogramItem | "none")[]>({
  key: "omni-pinned-label-options",
  value: ["cdt3Priority", "salesAmount"],
});

export const planogramSelectedItemsAtom = omniAtom({
  prefix,
  key: "selectedItems",
  value: [] as PlanogramSelectedItem[],
});

export const planogramNewRendererAtom = omniAtom({
  prefix,
  key: "newRenderer",
  value: false,
});

/**
 * Persisted renderer preference controlled from planogram editor pages. It only
 * affects editor/viewer pages that explicitly opt in; PDF export stays on the
 * legacy DOM renderer.
 */
export const planogramKonvaRendererAtom = omniAtomWithStorage({
  prefix,
  key: "konvaRenderer",
  value: true,
});

export const showShelfOverflowAtom = omniAtom({
  prefix,
  key: "showShelfOverflow",
  value: true,
});
